/**
 * SignatureRemindersCard — relance auto des documents à signer (Paramètres → Notifications).
 * Courriel J+N1, second courriel J+N2, alerte dans les notifications de la gestion J+N3. Arrêt dès signature.
 */
import { useState } from "react";
import { MailWarning, Play, Loader2 } from "lucide-react";
import { api } from "@/api";
import { toast } from "@/lib/toast";

export default function SignatureRemindersCard({ value, onChange }) {
  const cfg = { enabled: true, step1_days: 5, step2_days: 10, alert_days: 14, ...(value || {}) };
  const [running, setRunning] = useState(false);
  const set = (k, v) => onChange({ ...cfg, [k]: v });

  const runNow = async () => {
    setRunning(true);
    try {
      const r = await api.post("/admin/signature-reminders/run-now");
      toast.success(r.data.enabled ? `${r.data.checked} document(s) vérifié(s) · ${r.data.emails} courriel(s) · ${r.data.alerts} alerte(s)` : "Relance désactivée");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur");
    } finally {
      setRunning(false);
    }
  };

  const num = (k, label) => (
    <label className="text-xs text-slate-600">
      {label}
      <input type="number" min="1" max="90" value={cfg[k]} onChange={(e) => set(k, Number(e.target.value))}
        className="mt-0.5 w-full border rounded-lg px-2 py-1.5 text-sm" data-testid={`sig-rem-${k}`} />
    </label>
  );

  return (
    <div className="bg-white border rounded-xl p-5 space-y-3" data-testid="signature-reminders-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h3 className="font-semibold text-sm flex items-center gap-2"><MailWarning className="w-4 h-4 text-amber-600" /> Relance auto des documents à signer</h3>
        <button onClick={() => set("enabled", !cfg.enabled)}
          className={`px-3 py-1.5 rounded-lg text-xs font-semibold border ${cfg.enabled ? "bg-emerald-50 border-emerald-300 text-emerald-700" : "bg-gray-50 text-gray-500"}`}
          data-testid="sig-rem-toggle">
          {cfg.enabled ? "Activée" : "Désactivée"}
        </button>
      </div>
      <p className="text-xs text-slate-500">
        Mandats fiscaux, documents PDF, contrats de services, questionnaires et rapports d'impôt toujours en attente :
        courriel de rappel au client, second rappel avec le lien, puis alerte dans vos notifications. S'arrête dès que le client signe.
        Passe quotidienne à 10 h.
      </p>
      <div className="grid grid-cols-3 gap-3">
        {num("step1_days", "1er rappel (jours)")}
        {num("step2_days", "2e rappel (jours)")}
        {num("alert_days", "Alerte gestion (jours)")}
      </div>
      <button onClick={runNow} disabled={running} className="border border-amber-300 text-amber-700 hover:bg-amber-50 px-4 py-2 rounded-lg text-sm disabled:opacity-50 flex items-center gap-2" data-testid="sig-rem-run-now">
        {running ? <Loader2 className="w-4 h-4 animate-spin" /> : <Play className="w-4 h-4" />} Lancer la passe maintenant
      </button>
    </div>
  );
}
